import axios from "../../config/axiosConfig";
import {
  NON_ISSUE_READY_GOODS_YARN_STOCK_REPORT_REQUEST,
  NON_ISSUE_READY_GOODS_YARN_STOCK_REPORT_SUCCESS,
  NON_ISSUE_READY_GOODS_YARN_STOCK_REPORT_FAILURE,
  NON_ISSUE_READY_GOODS_YARN_STOCK_FILTER_REPORT_REQUEST,
  NON_ISSUE_READY_GOODS_YARN_STOCK_FILTER_REPORT_SUCCESS,
  NON_ISSUE_READY_GOODS_YARN_STOCK_FILTER_REPORT_FAILURE,
} from "../types/non-issue-ready-goods-yarn-stock-report-types";

export const getNonIssueReadyGoodsYarnStockReportReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: NON_ISSUE_READY_GOODS_YARN_STOCK_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        book_ids: params?.book_ids,
        filterType: params?.filterType, 
        selectedBills: params?.selectedBills, 
        selectedParties: params?.selectedParties, 
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };

      // Log the request parameters
      // console.log('Request Param Datas >>>>>>>>>>>>>>>>>>>>>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/stock-detail/getNonIssueReadyGoodsYarnStockReport?${queryString}`;

      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: NON_ISSUE_READY_GOODS_YARN_STOCK_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Register Report:", error);
        dispatch({ type: NON_ISSUE_READY_GOODS_YARN_STOCK_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Sales Register Report:", error);
      dispatch({ type: NON_ISSUE_READY_GOODS_YARN_STOCK_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getYarnStockFilterDetail = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: NON_ISSUE_READY_GOODS_YARN_STOCK_FILTER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        commanMaster: auth?.company?.Common_Master,
      };

      // Merge default params with provided params
      const requestParams = { ...defaultParams };

      // Log the request parameters
      // console.log('Request Param Datas >>>>>>>>>>>>>>>>>>>>>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/stock-detail/getYarnStockFilterDetail?${queryString}`;

      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: NON_ISSUE_READY_GOODS_YARN_STOCK_FILTER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Register Report:", error);
        dispatch({ type: NON_ISSUE_READY_GOODS_YARN_STOCK_FILTER_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Sales Register Report:", error);
      dispatch({ type: NON_ISSUE_READY_GOODS_YARN_STOCK_FILTER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearNonIssueReadyGoodsYarnStockReportReport = () => {
  return async (dispatch) => {
    dispatch({ type: NON_ISSUE_READY_GOODS_YARN_STOCK_REPORT_SUCCESS, payload: {} });
  }
}
